import React from 'react';
import { Field } from 'redux-form';
import moment from 'moment';
import { ReduxFormSelect } from '@common/components/FormElements';

const optionsForPerDateTime = (options) =>
  options.map((option, index) => ({
    label: `${moment(option.startDate).format('MMM DD')} - ${option?.time?.substr(0, 5)}`,
    value: index,
  }));

export const PerDateTime = ({ id, options }) => (
  <Field
    component={ReduxFormSelect}
    name={`extras.${id}.option`}
    options={optionsForPerDateTime(options)}
  />
);
